import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=aec0c1dc&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "./Team.vue?vue&type=style&index=0&id=aec0c1dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec0c1dc",
  null
  
)

component.options.__file = "Team.vue"
export default component.exports